import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DeployedYear, EmptyString, FormTypeAdd, FormTypeEdit, InsertDateFormat, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import { ApiDeletePayment, ApiGetBookingList, ApiGetPayment, ApiInsertDepositReturn, ApiInsertPayment, ApiUpdatePayment } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment"
import { money } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import DatePicker from "components/Input/DatePicker"

export default function DepositReturnForm(){
    useEffect(() => {
        // setLoading({isOpen: true})

        // fGetYear()
        // fGetBookingList().then(() => {
        //     if (formType ===  FormTypeEdit){
        //         setLoading({isOpen: true})

        //         fGetPayment().then(() => {
        //             setLoading({isOpen: false})
        //         })
        //     }else{
        //          setLoading({isOpen: false})
        //     }
        // })
        
    }, [])

    const navigate = useNavigate()

    const { fetch: insertPayment } = useFetch(ApiInsertPayment)
    const { fetch: updatePayment } = useFetch(ApiUpdatePayment)
    const { fetch: deletePayment } = useFetch(ApiDeletePayment)
    const { fetch: getPayment } = useFetch(ApiGetPayment)
    const { fetch: getBookingList } = useFetch(ApiGetBookingList)
    const { fetch: createDeposit } = useFetch(ApiInsertDepositReturn)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramPaymentId = queryString.get("paymentId")

    const [paymentDate, setPaymentDate] = useState(new Date())
    const [paymentType, setPaymentType] = useState(EmptyString)
    const [bookingOptions, setBookingOptions] = useState([])
    const [bookingId, setBookingId] = useState(EmptyString)
    const [paymentPeriodeMonth, setPaymentPeriodeMonth] = useState(moment(new Date()).format("M"))
    const [yearOptions, setYearOptions] = useState([])
    const [paymentPeriodeYear, setPaymentPeriodeYear] = useState(EmptyString)
    const [amount, setAmount] = useState(EmptyString)
    const [remark, setRemark] = useState(EmptyString)

    const [returnDate, setReturnDate] = useState(new Date())
    const [returnAmount, setReturnAmount] = useState(EmptyString)
    const [depositAmount, setDepositAmont] = useState('1.000.000')
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    
    const [errorTenantName, setErrorTenantName] = useState(false)
    const [errorReturnAmount, setErrorReturnAmount] = useState(false)
    
    const returnAmountChange = (e) => { 
        let value = e.target.value.replaceAll(',', '')
        let amount = value === '' ? 0 : parseFloat(value)
        let maxDeposit = 1000000
        
        if (amount > maxDeposit){

        } else {
            setReturnAmount(e.target.value)
        }
    }
    const returnDateChange = (e) => {
        if (e === null){
            setReturnDate(new Date())
        } else {
            setReturnDate(e)
        }
    }
    
    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    const saveBtnClick = () => {
        if (validateForm()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                fCreateDeposit().then(() => {
                    setLoading({ isOpen: false })
                })
            }}})
        }
    }
    const deleteBtnClick = () => { 
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            fDeletePayment().then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    function validateForm(){
        let errorCount = 0

        if (returnAmount === EmptyString){
            errorCount++
            setErrorReturnAmount(true)
        }else{
            setErrorReturnAmount(false)
        }

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }
    function fGetYear(){
        let deployedYear = parseFloat(DeployedYear)
        let thisYear = parseFloat(moment(new Date()).format("yyyy"))
        let tempArray = []

        if (thisYear > deployedYear){
            for(let i = deployedYear; i < (thisYear + 3); i++){
                let tempArray = []
                tempArray.push({label: String(i), value: String(i)})                
            }
        }else{
            for(let i = deployedYear; i < (deployedYear + 3); i++){                
                tempArray.push({label: String(i), value: String(i)})
            }
        }

        setYearOptions(tempArray)
    }

    // Function Api Call
    async function fCreateDeposit(){
        await createDeposit({
            data: {
                paymentId: paramPaymentId,
                depositStatus: '1',
                amount: returnAmount.replaceAll(',', '')
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            setSuccessModal({  isOpen: false }) 
                            navigate('/deposit')
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fDeletePayment(){
        await deletePayment({
            data:{
                paymentId: paramPaymentId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/payment") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    return (
        <div className="flex flex-col gap-2">
            <div>
                <div className="flex flex-col sm:flex-row justify-between">
                    <span className="font-semibold text-2xl">Deposit Return Detail</span>
                    {/* <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                        <span className="text-xs sm:text-sm opacity-60">
                            Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                        </span>
                    </div> */}
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Return Date</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <DatePicker className="w-full h-10 bg-white" value={returnDate} onChange={returnDateChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorTenantName ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Tenant Name is required!</span>
                    </div>
                </div>
                
                <div className="my-2">
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Deposit Amount</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                { depositAmount }
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Returned Amount</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <div className="flex rounded-md w-full border border-app-light-grey">
                                    <div className="py-2 px-4 border-r">
                                        <span>Rp</span>
                                    </div>
                                    <input className="bg-white w-full px-4 py-2 text-right" type="" value={money(returnAmount)} onChange={returnAmountChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorReturnAmount ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Return Amount is required!</span>
                    </div>
                </div>

                <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    {/* <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                    <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} /> */}
                    <BackButton onClick={backBtnClick}  />
                </div>
            </div>
                
            {/* Modal */}
 			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
 			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}